import { PendingContributionsService_pendingContributionsServiceGetQuery } from '@festina/moneyin-general-types/moneyin/hooks/PendingContributionsService_pendingContributionsServiceGetQuery'

export const useFetchPendingContributions =
  PendingContributionsService_pendingContributionsServiceGetQuery.useSuspenseQuery
